import React from "react";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import loadable from "@loadable/component";
const CreateBrokerComponent = loadable(
  () => import("../../components/Broker/CreateBroker")
);

const CreateBoker = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["broker"],
    navigateURL: "/",
  });
  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.BROKER;
    const formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Broker
        </span>
      </div>
      <CreateBrokerComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </>
  );
};

export default CreateBoker;
